export default from './Preview';



// WEBPACK FOOTER //
// ./src/components/Preview/index.js


// WEBPACK FOOTER //
// webpack:///src/components/Preview/index.js